import { ContextService } from '../../../services/context_service';
import { DateneingabeBetrieblicheDatenStandort } from '../DateneingabeBetrieblicheDatenStandort';
import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { RoutingIDs } from '../../../helpers/RoutingIDs';
import { StandorteEigenstromTabs } from './eigenstrom/StandortEigenstromTabs';
import { StandorteEnergietraeger } from './StandortEnergietraeger';
import { StandorteFahrzeuge } from './StandorteFahrzeuge';
import { StandorteGebaeude } from './StandorteGebaeude';
import { StandorteMaschinen } from './StandorteMaschinen';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import '../../../css/tabs.css';
import '../../../css/tabs-bereiche.css';
import { getGewerk } from '../../../main/functions/getGewerk';

interface StandorteDetailProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortSelected: any;
}

interface StandorteDetailState {
    tabIndex: number;
}

export class StandorteDetail extends React.Component<StandorteDetailProps, StandorteDetailState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: this.contextService.get('tabIdxStandorteDetail') ? this.contextService.get('tabIdxStandorteDetail') : 0
        };
    }

    @lazyInject(ContextService) private contextService: ContextService;

    componentDidMount(): void {
        const routing: any = this.props.routing || {};
        const tabName: string = RoutingIDs.TABS_STANDORTE_DETAIL;
        if (routing.path && routing.path[tabName] !== undefined) {
            this.setState({ tabIndex: routing.path[tabName] }, () => {
                if ((routing.path.terminateOn || null) === tabName) {
                    this.props.onRoutingChange({});
                }
                // WAEW-327 ->  1369
                this.contextService.set('tabIdxStandorteDetail', this.state.tabIndex);
            });
        }
    }

    render(): JSX.Element {
        const data: any = this.props.data || {};
        const gewerk = getGewerk(this.props.data);
        const hasGewerke: boolean = gewerk !== undefined && gewerk > 0;
        const isCfm: boolean = data.MODUL_SELECTED === 'cfm';
        const konfiguration: any = (data[IDs.ENT_KONFIGURATION] || [])[0] || {};
        const disabledEnergietraeger: boolean = konfiguration.daten_standorte_energietraeger_orig !== 1;
        const disabledErneuerbareEnergien: boolean = konfiguration.daten_erneuerbare_energien_orig !== 1;
        const disabledFahrzeuge: boolean = !hasGewerke || konfiguration.daten_fahrzeuge_orig !== 1 || isCfm;
        const disabledGebaeude: boolean = !hasGewerke || konfiguration.daten_standorte_gebaeude_orig !== 1;
        const disabledMaschinen: boolean = !hasGewerke || konfiguration.daten_maschinen_orig !== 1 || isCfm;
        const disabledStandorte: boolean = !hasGewerke || konfiguration.mehrere_standorte_orig !== 1;

        const showNone = disabledEnergietraeger && disabledErneuerbareEnergien && disabledFahrzeuge &&
            disabledGebaeude && disabledMaschinen && disabledStandorte;

        return (
            <div style={{ minWidth: 800 }}>
                <div>
                    <b>Standort: {this.props.standortSelected.name}</b>
                </div>
                {showNone &&
                    <div style={{ marginTop: 20 }}>
                        In diesem Bereich sind aufgrund der gegenwärtigen Konfiguration keine Dateneingaben möglich!
                    </div>
                }
                {!showNone &&
                    <Tabs
                        className={'tabs-dateneingabe'}
                        selectedIndex={this.state.tabIndex}
                        onSelect={
                            (tabIndex, lastIndex, event) => this.setState(
                                { tabIndex },
                                () => this.contextService.set('tabIdxStandorteDetail', this.state.tabIndex)
                            )
                        }
                    >
                        <TabList>
                            <Tab>Standort</Tab>
                            <Tab disabled={disabledGebaeude}>Gebäude</Tab>
                            <Tab disabled={disabledMaschinen}>Maschinen / Anlagen / Heizung</Tab>
                            <Tab disabled={disabledFahrzeuge}>Fahrzeuge</Tab>
                            <Tab disabled={disabledEnergietraeger}>Energieträger</Tab>
                            <Tab disabled={disabledErneuerbareEnergien}>Erneuerbare Energien / Eigenstrom</Tab>
                        </TabList>
                        <TabPanel>
                            <DateneingabeBetrieblicheDatenStandort
                                data={this.props.data}
                                standortSelected={this.props.standortSelected}
                            />
                        </TabPanel>
                        <TabPanel>
                            {!disabledGebaeude &&
                                    <StandorteGebaeude
                                    data={this.props.data}
                                    onRoutingChange={this.props.onRoutingChange}
                                    routing={this.props.routing}
                                    standortSelected={this.props.standortSelected}
                                />
                            }
                        </TabPanel>
                        <TabPanel>
                            {!disabledMaschinen &&
                                <StandorteMaschinen
                                    data={this.props.data}
                                    onRoutingChange={this.props.onRoutingChange}
                                    routing={this.props.routing}
                                    standortSelected={this.props.standortSelected}
                                />
                            }
                        </TabPanel>
                        <TabPanel>
                            {!disabledFahrzeuge &&
                                <StandorteFahrzeuge
                                    data={this.props.data}
                                    onRoutingChange={this.props.onRoutingChange}
                                    routing={this.props.routing}
                                    standortSelected={this.props.standortSelected}
                                />
                            }
                        </TabPanel>
                        <TabPanel>
                            {!disabledEnergietraeger &&
                                <StandorteEnergietraeger
                                    standortSelected={this.props.standortSelected}
                                />
                            }
                        </TabPanel>
                        <TabPanel>
                            {!disabledErneuerbareEnergien &&
                                <StandorteEigenstromTabs
                                    onRoutingChange={this.props.onRoutingChange}
                                    routing={this.props.routing}
                                    standortSelected={this.props.standortSelected}
                                    typeFilter={undefined}
                                    data={this.props.data}
                                />
                            }
                        </TabPanel>
                    </Tabs>
                }
            </div>
        );
    }
}
